<template>
    <div>
        <el-dialog :width="modelStep != 3 ? '25%' : '35%'" :visible="dialogVisible"  @close="cancel">
            <!-- title slot -->
            <span slot="title" class="title">
                <i :class="[iconMap[icon]]"></i>
                    {{ title }}
                    <!-- <a  v-if="showHis" @click="dialogVisible = false">查看申请历史</a> -->
            </span>
            <!-- default slot -->
            <div class="content">
                <p v-html="msg" v-if="modelStep != 3"></p>
                <el-form v-else style="box-sizing: border-box; padding-right: 40px;" :model="myform" label-width="80px" :rules="{desc: [{required: true, message: '备注为必填'}]}">
                    <el-form-item label="备注：" prop="desc">
                        <el-input type="textarea" :rows="3" v-model="myform.desc" :placeholder="`请授权查看${type == 1 ? '专家评审进度' : '专家评分明细'}`"></el-input>
                    </el-form-item>
                </el-form>
                <div v-if="markList.length > 0" style="box-sizing: border-box; padding-left: 40px; color: #afaeae;">
                    <div v-for="(item, index) in markList" :key="index">{{ item }}</div>
                </div>
            </div>

            <!-- footer slot -->
            <span slot="footer" :style="footerStyle">
                <el-button v-show="modelStep == 3" @click="cancel">取消</el-button>
                <el-button type="primary" @click="sure">确定</el-button>
            </span>

        </el-dialog>
    </div>
</template>

<script>
const iconMap = {
    'success': 'el-icon-success',
    'warning': 'el-icon-warning warning',
    'info': 'el-icon-info info',
    'error': 'el-icon-error'
}
export default {
    data() {
        return {
            dialogVisible: false,
            iconMap,
            title: '提醒',
            icon: 'warning',
            showHis: false,
            msg: '',
            markList: [],
            myform: {
                desc: ''
            },
            agree: null,
            modelStep: 1,
        }
    },
    computed: {
        footerStyle() {
            if(this.modelStep != 3) {
                return {
                    display: 'flex',
                    justifyContent: 'center',
                }
            }
            return ''
        }
    },
    methods: {
        closed() {
            this.dialogVisible = false
            this.msg = ''
            this.markList = []
            this.myform.desc = ''
            this.agree = null
            this.$emit('closed')
        },
        async getMsg() {
            // const res = await this.$http.get('/api/xxx')
            let msg
            try {
                if (this.modelStep === 1) {
                    const res = await this.$http.post(`/evaluationProcess/premise`, this.params)
                    if (res.data.code == 1) {
                        // this.id = res.data.data.id
                        // this.processinstanceid = res.data.data.processinstanceid
                        // this.applyStatus = res.data.data.applyStatus
                        this.apply(3, this.params)
                        return
                    } else {
                        // `【<span style="color: red">xxxxxxxxxxxxx</span>】项目的专家报道时间(<span style="color: red">xxxxxx</span>)未到，无法申请!`
                        msg = res.data.msg
                    }
                } else if (this.modelStep === 2) {
                    msg = `您的授权申请已于<span style="color: red">xxxxxxxxxxxxx</span>提交目前处于“待授权“状态，请等传授议结果，授权通过后方可查看!`
                    this.markList = ['备注：申请30分钟后无授权结果可再次发起申请']
                    this.showHis = true
                } else if (this.modelStep === 3) {
                    msg = `安的授权申请日于<span style="color: red">2023-08-10 16:12:26</span>提交1分钟内无法再次提交，请稍后再试!`
                    this.title = '申请授权'
                    this.showHis = true
                    this.icon = 'info'
                    this.markList = ['备注：申请间隔需大于1分钟', '备注: 申请通过后可查看30分钟']
                } else {
                    this.title = '提醒'
                    this.showHis = true
                    this.icon = 'warning'
                    this.markList = []
                    // msg = `安的授权申请日于<span style="color: red">2023-08-10 16:12:26</span>提交1分钟内无法再次提交，请稍后再试!`
                }
            } catch (error) {
                msg = '网络错误'
            }
            return msg
        },
        async apply(modelStep = 1, params) {
            if (params && params.type) {
                this.type = params.type
            }
            this.params = params
            this.modelStep = modelStep
            const msg = await this.getMsg()
            if (msg) {
                this.msg = msg
                this.dialogVisible = true
            }
        },
        sure() {
            this.agree = true

            setTimeout(() => {
                if (this.modelStep < 4) {
                    if (this.modelStep === 3) {
                        // todo
                        // this.$emit('sure')
                        this.$http.post(`/evaluationProcess/startWorkFlow`, {
                            bidSectionCode: this.$route.query.id,
                            type: this.type,
                            variables: {
                                commit: true,
                                opinion: this.myform.desc
                            }
                        }).then(res => {
                            if (res.data.code == 1) {
                                this.$message.success('短信发送成功')
                                this.$refs.myform.resetFields()
                                this.myform.desc = ''
                                this.dialogVisible = false
                                this.$emit('refresh')
                                this.dialogVisible = false
                            } else {
                                // this.$message.error(res.data.msg)
                                this.msg = res.data.msg
                                this.apply(4)
                            }
                        })
                        return
                    }
                    // this.modelStep++
                    // this.apply(this.modelStep)
                    this.dialogVisible = false
                }
            }, 300)
        },
        cancel() {
            this.closed()
            this.agree = false
        }
    }

}
</script>

<style lang="less" scoped>
.title {
    font-size: 16px;
    a {
        margin-left: 10px;
    }
    .warning {
        color: #f90;
    }
    .info {
        color: #2db7f5;
    }

}

/deep/ .el-dialog__header {
    padding-top: 18px;
}

</style>